import axios from "axios";
import { BACKEND_SERVER_URL } from "../../../http/http-config";

export async function getBookLessonData(sectionId) {
    try {
        const response =await axios.get(BACKEND_SERVER_URL + `/getBookLessonData/${sectionId}`);
        return response.data.lessonData;
    } catch (error) {
        console.error('Error fetching book lesson data:', error);
        throw error;
        
    }  
}
